<!-- {{cardContent|json}} -->
<!-- {{categoryType}} -->
<div class="card-wrapper {{size}}-card" [ngClass]="(flavor === 'edged') ? 'edged' : ''">
    <section class="blurred-overlay" *ngIf="!cardContent">
    </section>
    <section class="img-section" (click)="offerAction('knowMore')">
        <img [defaultImage]="'../../../assets/images/image-coming-soon.png'" [lazyLoad]="cardContent.image_url">
    </section>
    <section *ngIf="size !== 'small' " class="img-badge" (click)="offerAction('knowMore')">
        <img [defaultImage]="'../../../assets/images/image-coming-soon.png'" [lazyLoad]="cardContent.logo_url">
    </section>
    <section *ngIf="size !== 'small' && (listOfOffers.length > 1 ||
      (selectedOfferMerchantDetails
      && selectedOfferMerchantDetails.offers_count
      && selectedOfferMerchantDetails.offers_count > 1))" class="offer-badge" (click)="offerAction('knowMore')">
      <div class="offer-text">{{(listOfOffers.length > 1) ? listOfOffers.length : selectedOfferMerchantDetails.offers_count }} Offers</div>
      <img *ngIf="flavor === 'edged'"  src="../../../assets/svg/Shadow.svg">
    </section>
    <section class="card-content" (click)="offerAction('knowMore')">
        <label>{{cardContent.name}}</label>
        <div class="description">
            {{cardContent?.title}}
        </div>
    </section>
    <section class="btn-section">
        <app-poshvine-button class="col-md-6 col-sm-6" [text]="(!selectedOffer?.attributes?.claimable) ?'Claimed':(size === 'small')? 'Claim':'Claim offer'"
        (click)="(!selectedOffer?.attributes?.claimable)?'':offerAction('claim')"
        [isDisabled]="!selectedOffer?.attributes?.claimable">
        </app-poshvine-button>
        <app-poshvine-button class="col-md-6 col-sm-6" [text]="'Know more'" [type]="'secondary'"
            (click)="offerAction('knowMore')"></app-poshvine-button>
    </section>
</div>

